import {
  AnalyticsProvider,
  Traits,
  userEvent,
} from '../interfaces/EventInterfaces'
import { AnalyticsBrowser } from '@segment/analytics-next'
import getConfig from 'next/config'
import SegmentInjectTraitsPlugin from '../core/plugins/SegmentInjectTraitsPlugin'
import SegmentInjectCampaignPlugin from '../core/plugins/SegmentInjectCampaignPlugin'
import SegmentInjectOptionsPlugin from '../core/plugins/SegmentInjectOptionsPlugin'
import SegmentInjectUTMPlugin from '../core/plugins/SegmentInjectUTMPlugin'
import { parseCookies } from 'nookies'
import { getSessionId } from '../services/AmplitudeService'

const {
  publicRuntimeConfig: { SEGMENT_ANALYTICS_KEY },
} = getConfig()

export const analytics = AnalyticsBrowser.load({
  writeKey: SEGMENT_ANALYTICS_KEY,
  plugins: [
    SegmentInjectTraitsPlugin,
    SegmentInjectCampaignPlugin,
    SegmentInjectOptionsPlugin,
    SegmentInjectUTMPlugin
  ],
})

class SegmentProvider implements AnalyticsProvider {

  async getOptions(userId: string | null) {
    const gaClientId = this.extractGaClientId()
    const integrations: Record<string, any> = {
      'Google Analytics': { clientId: gaClientId },
    }

    if (userId) {
      const amplitudeSessionId = await this.getAmplitudeSessionId(userId)
      if (amplitudeSessionId) {
        integrations['Actions Amplitude'] = {
          session_id: amplitudeSessionId,
        }
      }
    }

    return { integrations }
  }

  extractGaClientId() {
    const gaCookieName = '_ga'
    const cookie = parseCookies()
    const gaCookie = cookie[gaCookieName]
    return gaCookie?.split('.').slice(-2).join('.') ?? null
  }

  async getAmplitudeSessionId(userId: string): Promise<string | null> {
    const amplitudeSessionId = await getSessionId(userId)
    return amplitudeSessionId
  }

  async identifyUser(traits: Traits, userId?: string): Promise<void> {
    try {
      const options = await this.getOptions(userId ?? null)
      if (userId) {
        await analytics?.identify(userId, { ...traits }, { ...options })
      } else {
        await analytics?.identify({ ...traits }, { ...options })
      }
    } catch (error) {
      console.error('Error identifying user in Segment: ', error)
      throw error
    }
  }

  async trackEvent(event: userEvent): Promise<void> {
  await analytics.track(event.eventName, event.params)
  }
}

export default SegmentProvider
